import { getDistributor } from '@raisin/cp-utils';
import { createAsyncAction, METHODS } from 'api';
import { MICROSERVICES_NAMES } from 'api/types';
import { orderOptions, sortingOptions } from 'types';
import { getDistributionChannelId } from 'utils/getDistributionChannel';

const fetchBanks = async ({ locale }: { locale: string }, sortBy = sortingOptions.BANK_NAME) => {
  try {
    const distributorId = getDistributor();
    const distributionChannelId = getDistributionChannelId(locale);

    const settings = {
      params: {
        distributor_id: distributorId,
        distribution_channel_id: distributionChannelId,
        sort_by: sortBy,
        ...(sortBy === sortingOptions.RATING && { order_by: orderOptions.DESC }),
        limit: 9999,
      },
    };

    return await createAsyncAction(
      locale,
      MICROSERVICES_NAMES.DBS,
      'dbs.banks',
      METHODS.GET,
      settings,
    );
  } catch (error) {
    console.error('Failed to fetch bank data for locale: ', locale);
  }
};
export default fetchBanks;
